import { API_ENDPOINTS, DEFAULT_PROXY } from "@skinsoft/network"

export class BatchApiService {

    private rootEndpoint: string = API_ENDPOINTS.batch
    private proxy = DEFAULT_PROXY

    public getAllBatchesSharedWithUser(userId: string) {
        const endpoint = `${this.rootEndpoint}/shared?user=${userId}`

        return this.proxy.fetch(endpoint).pipe()
    }

    public getAllUserBatches(userId: string) {
        const endpoint = `${this.rootEndpoint}/ofUser?user=${userId}`

        return this.proxy.fetch(endpoint).pipe()
    }
}